import {hel_set_fatal_error_dialog, hel_show_fatal_error_dialog} from './logics/widgetErrorDialog';

import type {WidgetErrorDialog} from './logics/widgetErrorDialog';

Object.assign(globalThis, {
  /**
   * @remarks
   * JSまたはHSから参照の想定
   */
  hel_set_fatal_error_dialog,

  /**
   * 外部遷移URLやボタンテキストをセット
   * @remarks
   * JSまたはHSから参照の想定
   */
  hel_set_data_fatal_error_dialog: (
    setting: Parameters<InstanceType<typeof WidgetErrorDialog>['setData']>[0]
  ) => {
    const customElementName = 'widget-error-dialog';
    const widgetErrorDialog: WidgetErrorDialog | null = document.querySelector(customElementName);
    if (widgetErrorDialog) {
      widgetErrorDialog.setData(setting);
    } else {
      console.debug('hel_set_fatal_error_dialog yet');
    }
  },

  hel_show_fatal_error_dialog
});

hel_set_fatal_error_dialog();
